var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2146 36.6847C28.0769 36.6847 36.0717 28.6964 36.0717 18.8424C36.0717 8.9883 28.0769 1 18.2146 1C8.35234 1 0.357422 8.9883 0.357422 18.8424C0.357422 28.6964 8.35234 36.6847 18.2146 36.6847Z",
    fill: "#010F0E",
    stroke: "white",
    strokeWidth: 0.142857,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21444 8.50488L15.7499 19.908L7.16064 29.1793H9.0939L16.614 21.062L22.6897 29.1793H29.2683L20.2523 17.1349L28.2473 8.50488H26.314L19.3886 15.9806L13.7929 8.50488H7.21444ZM10.0574 9.92758H13.0795L26.425 27.7566H23.4029L10.0574 9.92758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.714394b1278f4ec9d5c842d579bd74f0.svg";
export { ForwardRef as ReactComponent };